function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import counterpart from "counterpart";
import { DepositModalContent } from "./DepositModal";
import { WithdrawModalContentNew } from "./WithdrawModalNew";
import { Modal, Button, Tabs } from "bitshares-ui-style-guide";

class GatewaysModal extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Modal, {
      destroyOnClose: true,
      title: counterpart.translate("gateways"),
      id: this.props.modalId,
      className: this.props.modalId,
      onCancel: this.props.hideModal,
      overlay: true,
      footer: [/*#__PURE__*/React.createElement(Button, {
        key: "cancel",
        onClick: this.props.hideModal
      }, counterpart.translate("modal.close"))],
      visible: this.props.visible,
      noCloseBtn: true,
      width: 700
    }, /*#__PURE__*/React.createElement(Tabs, {
      defaultActiveKey: "deposit"
    }, /*#__PURE__*/React.createElement(Tabs.TabPane, {
      tab: counterpart.translate("deposit"),
      key: "deposit"
    }, /*#__PURE__*/React.createElement(DepositModalContent, _extends({
      hideModal: this.props.hideModal
    }, this.props))), /*#__PURE__*/React.createElement(Tabs.TabPane, {
      tab: counterpart.translate("withdraw"),
      key: "withdraw"
    }, /*#__PURE__*/React.createElement(WithdrawModalContentNew, _extends({}, this.props, {
      hideModal: this.props.hideModal
    })))));
  }

}

export default GatewaysModal;